export const DEFAULT_MAP_TYPES = [
  { label: "actionTrajectory", value: "actionTrajectory" },
  { label: "action18Zone", value: "action18Zone" },
  { label: "formationMap", value: "formationMap" },
  { label: "locationHeatMap", value: "locationHeatMap" },
  { label: "location18Zone", value: "location18Zone" },
]

export const DEFAULT_ACTION_TYPES = [
  { label: "runEffort1", value: "R1" },
  { label: "runEffort2", value: "R2" },
  { label: "runEffort3", value: "R3" },
  { label: "accelEffort1", value: "A1" },
  { label: "accelEffort2", value: "A2" },
  { label: "accelEffort3", value: "A3" },
  { label: "decelEffort1", value: "D1" },
  { label: "decelEffort2", value: "D2" },
  { label: "decelEffort3", value: "D3" },
]
